/**
 * Full-bleed embedded-section routes — own scoped nav/shell, no app sidebar.
 * Covers `/admin` (embedded AdminPanel package) and `/command-center` (its own
 * brandbook-styled nav rail + topbar, see `src/app/command-center/layout.tsx`).
 */
export function isAdminPanelFullscreenPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/admin' || normalized === '/command-center' || normalized.startsWith('/command-center/');
}

export function shouldHideAppSidebar(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  if (pathname.endsWith('/logic/preview')) return true;
  if (pathname.includes('/ai-agent')) return true;
  if (pathname === '/arc' || pathname.startsWith('/arc/')) return true;
  if (pathname.includes('/creatives/build')) return true;
  return isAdminPanelFullscreenPath(pathname);
}
